import { z } from "zod"

import { MATERIAL_TYPES } from "./material-types"

/** Validated `/settings/material-library` search params (table state lives in the URL). */
export const materialsSearchSchema = z.object({
	q: z.preprocess(
		(val) => (val === "" || val === null || val === undefined ? undefined : val),
		z.string().min(1).max(200).optional()
	),
	limit: z.coerce.number().int().min(1).max(200).default(25),
	offset: z.coerce.number().int().min(0).default(0),
	sort: z.string().default("manufacturer.asc"),
	material_type: z.enum(MATERIAL_TYPES).optional(),
	// Not `z.coerce.boolean()` — that turns any non-empty string (including "false") into true.
	include_dropped: z.preprocess((val) => val === true || val === "true", z.boolean()).default(false)
})

export type MaterialsSearch = z.infer<typeof materialsSearchSchema>

/** Use for `Link` / `redirect` to the page so validated search params are satisfied. */
export const defaultMaterialsSearch: MaterialsSearch = materialsSearchSchema.parse({})
